// Products targeted for the PDP Reviews Box experiment
export const PDP_REVIEWS_BOX_TARGETED_PRODUCTS = [
  "JWL0018",
  "JWL0124",
  "JWL0133",
  "JWL0205",
  "JWL0296",
  "JWL0515",
  "JWL0552",
  "JWLN0300",
  "JWLP0179",
  "JWLP0653",
  "JWLP0660",
  "PRM0019",
  "PRM0034",
  "JWL0063",
  "JWL0246",
  "JWLN0473-1",
  "JWL1049",
  "JWL0285",
  "JWLM0052",
  "JWE0002",
  "JWLP0655",
  "JWL0770",
  "JWLN0709-2",
  "JWLN0499",
  "JWLP0507",
  "JWLN0468-3",
  "JWLP0365",
  "JWLP0653-3",
  "JWL0789",
  "JWLN0721",
  "JWLP0710",
  "JWL0492",
]
